import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/src/app/live-signals-dashboard/components/LiveSignalsDashboardInteractive.tsx");
